// extracted by mini-css-extract-plugin
module.exports = {"message-custom-icon":"custom-message_message-custom-icon__36VRb"};